import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import router from '@/router'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const checkUnifiedNumber = () => {
  if (useAuthStore().isUserServiceCenter) {
    return
  }

  const formStore = useFormStore()
  const { personUnifiedNumber } = formStore.form.values
  const { serviceTransactionId } = formStore.extraMap
  if (!personUnifiedNumber) {
    formStore.form.setValues({
      gccClassCode: null
    })
  } else {
    getPersonProfile(personUnifiedNumber)
    if ([573, 574].includes(serviceTransactionId)) {
      searchFingerprintExemptionRequests(personUnifiedNumber)
    }
  }
}
const searchFingerprintExemptionRequests = async (personUnifiedNumber) => {
  const res = await apiHelperService.get(
    `/api/icaRequest/fingerprint-exemption-requests/search/${personUnifiedNumber}`
  )
}
const getPersonProfile = async (personUnifiedNumber) => {
  const res = await apiHelperService.get(`/api/icaRequest/getPerson/${personUnifiedNumber}`)
}
const onGccClassCodeChange = async () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const { gccClassCode = '', personUnifiedNumber = '', identityNumber = '' } = formStore.form.values
  if (gccClassCode && personUnifiedNumber) {
    try {
      const params = {
        moduleParentReasonId: gccClassCode,
        personIdentityNumber: identityNumber,
        personUnifiedNumber,
        serviceTransactionId: serviceTransactionId || 573
      }
      const result = await apiHelperService.get(
        '/api/icaRequest/checkValidatePersonByUnifiedNumber',
        {
          params
        }
      )
      if (!result) return
      if (!result.isValid) {
        formStore.form.setValues({
          personUnifiedNumber: undefined,
          gccClassCode: undefined
        })
        doNotify(i18n.global.t('ERRORS'), i18n.global.t(result.message))
      } else {
        loadTransactionReasons({
          serviceTransactionId,
          moduleParentReasonId: gccClassCode,
          existInSetupFlag: 0
        })
      }
    } catch (error) {
      console.error('onGccClassCodeChange', error)
    }
  }
}

const loadTransactionReasons = async (params) => {
  const formStore = useFormStore()
  try {
    const res = await apiHelperService.get(
      `/api/lookup/GetTransactionReasonsByModuleParentReasonId`,
      {
        params
      }
    )
    if (res && res.length > 0) {
      formStore.extraMap = {
        ...formStore.extraMap,
        showGccCategoryCodeList: true
      }
    }
  } catch (error) {
    console.error('loadTransactionReasons', error)
  }
}
const getValidationMessage = async () => {
  const formStore = useFormStore()
  const { gccCategoryCode } = formStore.form.values
  const { personUnifiedNumber, gccClassCode } = formStore.form.values
  if (personUnifiedNumber && gccCategoryCode === '496' && gccClassCode === '492') {
    const params = {
      personUnifiedNumber,
      gccCategoryCode
    }
    try {
      const res = await apiHelperService.get(`/api/icaRequest/getGccEligibilityMessage`, {
        params
      })
      formStore.extraMap.gccCategoryCode = gccCategoryCode
      if (res && res.isGccEligibleFlag) {
        doNotify(i18n.global.t('ERRORS'), i18n.global.t(res.validationMessage), undefined, 'error')
      } else {
        formStore.form.setValues({
          gccCategoryCode: undefined,
          isGccEligibleFlag: res.isGccEligibleFlag
        })
        doNotify(i18n.global.t('ERRORS'), i18n.global.t('notEligibleToApply'), undefined, 'error')
      }
    } catch (error) {
      console.error('getValidationMessage', error)
    }
  }
}

const setGccCategoryData = (options) => {
  const formStore = useFormStore()
  if (!options) return
  formStore.extraMap = {
    ...formStore.extraMap,
    gccClassificationList: options
  }
  return options
}

const setGccTypeData = (options) => {
  const formStore = useFormStore()
  if (!options) return
  formStore.extraMap = {
    ...formStore.extraMap,
    gccTypesList: options
  }
  return options
}

const setGccRelationData = (options) => {
  const formStore = useFormStore()
  if (!options) return
  formStore.extraMap = {
    ...formStore.extraMap,
    gccRelationList: options
  }
  return options
}

const setTypeId = () => {
  const formStore = useFormStore()
  const { gccTypeCode, gccCategoryCode } = formStore.form.values
  if (gccTypeCode && gccTypeCode != 0) {
    formStore.extraMap = {
      ...formStore.extraMap,
      gccTypeCode: gccTypeCode
    }
  } else {
    formStore.extraMap = {
      ...formStore.extraMap,
      gccTypeCode: gccCategoryCode
    }
  }
  if ([509, 510].includes(+formStore.extraMap.gccTypeCode)) {
    formStore.form.setValues({
      gccCategoryCode: undefined,
      gccTypeCode: undefined
    })
    doNotify(i18n.global.t('ERRORS'), i18n.global.t('notEligibleToApply'), undefined, 'error')
  }
}

export default function () {
  return {
    checkUnifiedNumber,
    onGccClassCodeChange,
    getValidationMessage,
    setGccCategoryData,
    setGccTypeData,
    setGccRelationData,
    setTypeId
  }
}
